import PropTypes from 'prop-types';

/* PropTypes */

export const JobChecklistFormPropTypes = {
  checklist: PropTypes.object,
  getResultHistories: PropTypes.func,
  isReportReviewer: PropTypes.bool,
  isUnderReviewing: PropTypes.bool,
  job: PropTypes.object,
  onSave: PropTypes.func,
  readonly: PropTypes.oneOfType([PropTypes.bool, PropTypes.string]),
  refetchReportReview: PropTypes.func,
  refetchResultHistories: PropTypes.func,
  reportReviewData: PropTypes.object,
  reportReviewStatistics: PropTypes.arrayOf(PropTypes.object),
  resultHistories: PropTypes.object,
  results: PropTypes.array,
  setResults: PropTypes.func,
  storedResult: PropTypes.object,
};

export const JobChecklistFormSectionPropTypes = {
  applyQuestionConditions: PropTypes.oneOfType([PropTypes.array, PropTypes.func]),
  checklistOutcomes: PropTypes.array,
  collapsedSections: PropTypes.array,
  getFactoryQuestion: PropTypes.func,
  getQuestionColor: PropTypes.func,
  getResult: PropTypes.func,
  getSectionQuestions: PropTypes.oneOfType([PropTypes.array, PropTypes.func]),
  indexPath: PropTypes.arrayOf(PropTypes.number),
  parentChecklistSectionIdAlias: PropTypes.string,
  questionResultDrawCallback: PropTypes.func,
  questionsWithMissingResults: PropTypes.array,
  reportReviewStatistics: PropTypes.arrayOf(PropTypes.object),
  section: PropTypes.object,
  sectionHeaderAdditions: PropTypes.func,
  sectionsOptions: PropTypes.array,
  selectedQuestion: PropTypes.object,
  setShowHistory: PropTypes.func,
  setShowNote: PropTypes.func,
  setShowResult: PropTypes.func,
  toggleSection: PropTypes.func,
  toggleSelectedQuestion: PropTypes.func,
  typeId: PropTypes.number,
  wrapperRef: PropTypes.object,
  allOutcomes: PropTypes.array,
  allNegativeOutcomes: PropTypes.array,
  negativeOutcomeResultIds: PropTypes.arrayOf(PropTypes.number),
  allPositiveOutcomes: PropTypes.array,
  positiveOutcomeResultIds: PropTypes.arrayOf(PropTypes.number),
  allOtherOutcomes: PropTypes.array,
  allOtherOutcomeResultIds: PropTypes.arrayOf(PropTypes.number),
  checklist: PropTypes.object,
};

export const LawMenuListPropTypes = {
  children: PropTypes.any,
  data: PropTypes.shape({
    label: PropTypes.string,
  }),
  isFiltered: PropTypes.bool.isRequired,
  setIsFiltered: PropTypes.func.isRequired,
};

export const LawOptionPropTypes = {
  data: PropTypes.shape({
    articleSecNo: PropTypes.string,
    internalGuidelineInterpretation: PropTypes.string,
    label: PropTypes.string,
    legalCitation: PropTypes.string,
    legalReqSummary: PropTypes.string,
  }),
};

export const LawSingleValuePropTypes = {
  data: PropTypes.shape({
    articleSecNo: PropTypes.string,
    label: PropTypes.string,
  }),
};

export const OverrideResultFamilyPropTypes = {
  excludedResult: PropTypes.number,
  isOverridingResultFamily: PropTypes.bool.isRequired,
  onChange: PropTypes.func.isRequired,
  onToggle: PropTypes.func.isRequired,
  resultFamilyId: PropTypes.number,
};

/* Default Props */

export const JobChecklistFormSectionDefaultProps = {
  getQuestionColor: null,
  indexPath: [],
  questionResultDrawCallback: null,
  questionsWithMissingResults: [],
  questions: [],
  sectionHeaderAdditions: null,
  allOutcomes: [],
  allNegativeOutcomes: [],
  negativeOutcomeResultIds: [],
  allPositiveOutcomes: [],
  positiveOutcomeResultIds: [],
  allOtherOutcomes: [],
  allOtherOutcomeResultIds: [],
};
